module.exports = __webpack_public_path__ + "img/hinge_1000.9cd589c7.png";